module.exports = __webpack_public_path__ + "static/media/LargeIntestine.3bc106cf.ogg";